module.exports = __webpack_public_path__ + "img/firefox-hero.9a032901.png";